export default __webpack_public_path__ + "static/media/3.b3de1e97.webp";